import { NamHocTruongKhoiHeFilter } from './../models/namHocTruongKhoiHeFilter';
import { NamHocCoSoFilter } from './../models/namHocCoSoFilter';
import { sf_saleset_register_dichvu_import_rq } from "../models/request/sale-set/sf_saleset_register_dichvu_import_rq";

import { apiClient } from "./apiClient";


export const SF_SALESET_KHOANNOPGROUP_TYPE_SELECT = "sf_saleset_khoannopgroup_type/select"
export const SF_SALESET_KHOANNOPGROUP_TYPE_SELECT_BY_COSO = "sf_saleset_khoannopgroup_type/select/by/coso";
export const SF_SALESET_KHOANNOPGROUP_TYPE_SELECT_TONG_HOP = "sf_saleset_khoannopgroup_type/select_tong_hop";
export const SF_SALESET_KHOANNOPGROUP_TYPE_SELECT_BY_HOCSINH = "sf_saleset_khoannopgroup_type/select/by/hocsinh";
export const SF_SALESET_KHOANNOPGROUP_TYPE_INSERT_MULTIPLE = "sf-saleset-khoannopgroup-type/insert-multiple";


export const saleSetKhoanNopGroupTypeApi = {
    select: (request: NamHocTruongKhoiHeFilter) =>
        apiClient.post(SF_SALESET_KHOANNOPGROUP_TYPE_SELECT, request),
    select_by_coso: (request: NamHocCoSoFilter) =>
        apiClient.post(SF_SALESET_KHOANNOPGROUP_TYPE_SELECT_BY_COSO, request),
    select_tong_hop: (request: NamHocCoSoFilter) =>
        apiClient.post(SF_SALESET_KHOANNOPGROUP_TYPE_SELECT_TONG_HOP, request),
    select_by_hocsinh: (request: { nam_hoc: string; ts_hocsinh_id: number }) =>
        apiClient.post(SF_SALESET_KHOANNOPGROUP_TYPE_SELECT_BY_HOCSINH, request),
    insert_multiple: (data: any) =>
        apiClient.post(SF_SALESET_KHOANNOPGROUP_TYPE_INSERT_MULTIPLE, data),
    getSheets: (file_name_uploaded: string) => apiClient.post(`sf-saleset-khoannopgroup-type/get_sheets?file_name_uploaded=${file_name_uploaded}`),
    readFiles: (rq: sf_saleset_register_dichvu_import_rq) => apiClient.post(`sf-saleset-khoannopgroup-type/read_file`, rq),
    import: (rq: sf_saleset_register_dichvu_import_rq) => apiClient.post(`sf-saleset-khoannopgroup-type/import`, rq),
}
